<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		>
			<template #heroContent>
				<div v-if="page.heroTitle" class="hero-content">
					<span class="hero-title">
						{{ page.heroTitle }}
					</span>
				</div>
			</template>
		</heading-image>

		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content
			:title="page.title || page.header"
			:subtitle="page.location"
			:introduction-content="page.introductionContent"
		>
			<div class="row">
				<div class="columns column6">
					<picture>
						<source :srcset="page.midSectionImage" />
						<source :srcset="page.midSectionImageWebp" type="image/webp" />
						<img :src="page.midSectionImage" loading="lazy" class="midsection-image" />
					</picture>
				</div>
				<div v-parse-links class="columns column6" v-html="page.content" />
			</div>
		</main-content>

		<section id="vacancyformwrapper" class="vacancy-form">
			<div class="row">
				<div class="form align-center">
					<h2>{{ $t('applyForVacancy') }}</h2>
					<contact-form
						name="vacancyform"
						:form="form"
						:extra-querydata="{ id: page.pageID }"
						single-column
					/>
				</div>
			</div>
		</section>

		<contentblocks :items="page.contentblocks" />

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: form } = await useWebsiteFetch('vacancyform', {
	query: { language: locale.value },
	key: `${locale.value}/vacancyform`,
});
</script>

<style lang="scss" scoped>
.divider-heading {
	padding-bottom: 0;

	.horizontal-divider {
		margin: 60px auto 0;
	}
}

.intro-bar {
	padding: 35px 0;

	.row {
		justify-content: space-between;
		align-items: center;
	}

	.button-cta {
		min-width: 170px;
	}
}

.back-to-overview {
	position: relative;
	min-width: 170px;
	background: none;
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;

	a {
		color: var(--body-color);
		text-decoration: none;
		text-transform: uppercase;
		padding: 0 0 5px;
	}

	svg {
		font-size: 18px;
		margin: 1px 15px -1px 0;
	}
}

.main-content {
	padding: 50px 0 0;

	:deep(h2),
	:deep(h3),
	:deep(h4) {
		margin: 0 0 10px;
	}

	.row {
		max-width: 1240px;
		padding-bottom: 50px;

		.column6 {
			padding: 0 50px 30px;
		}
	}
}

.vacancy-form .row {
	max-width: 1320px;
	background-color: var(--secondary-background-color);

	.form {
		padding: 50px;
	}
}

@media (max-width: 1080px) {
	.main-content .row {
		padding-bottom: 0;

		.column6 {
			padding: 0 20px 30px;
		}
	}
}

@media (max-width: 680px) {
	.intro-bar .row {
		flex-flow: row wrap;
		align-items: center;
		justify-content: center;
		gap: 10px;

		.button {
			margin: 10px auto 0;
		}
	}
}
</style>
